export function range(from, to) {
    if (to === undefined) {
        to = from - 1
        from = 0
    }
    return Array.from({ length: Math.max(0, to - from + 1) }, (_, i) => i + from)
}
